import { fitWithin } from './lib/weigh.js';

// Tablet cameras shoot 12 MP+; the "this is your fish" photo only needs to be clear on a phone.
// Downscale to 1600 px JPEG before upload (also turns odd formats into one the API accepts).
const MAX_EDGE = 1600;
const API_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const API_MAX_BYTES = 8 * 1024 * 1024;

/** A JPEG ready for the weigh upload, or the original when the browser can't decode it. */
export async function preparePhoto(file: File): Promise<Blob> {
  try {
    const bmp = await createImageBitmap(file);
    const { w, h } = fitWithin(bmp.width, bmp.height, MAX_EDGE);
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('no 2d context');
    ctx.drawImage(bmp, 0, 0, w, h);
    bmp.close();
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85));
    if (blob) return blob;
  } catch {
    /* fall through to the original */
  }
  if (API_TYPES.includes(file.type) && file.size <= API_MAX_BYTES) return file;
  throw new Error('This photo can’t be used. Take it again.');
}
